/* eslint-disable(prettier/prettier) */
// 🔴 DO NOT EDIT — This file is generated.

import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
const StarSparkleSvg = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M6.59503 4.05298L5.73858 3.7678L5.45249 2.91042C5.36015 2.63338 4.90114 2.63338 4.8088 2.91042L4.52271 3.7678L3.66627 4.05298C3.52775 4.09916 3.43359 4.22862 3.43359 4.37529C3.43359 4.52196 3.52775 4.65143 3.66627 4.6976L4.52271 4.98279L4.8088 5.84017C4.85497 5.97869 4.98444 6.07194 5.13019 6.07194C5.27595 6.07194 5.40632 5.97778 5.45159 5.84017L5.73768 4.98279L6.59412 4.6976C6.73264 4.65143 6.8268 4.52196 6.8268 4.37529C6.8268 4.22862 6.73355 4.09916 6.59503 4.05298Z"
      fill="none"
    />
    <path
      d="M14.4954 10.6041L17.0131 8.14965L12.4774 7.49145L10.4494 3.3811L8.42148 7.49145L3.88574 8.14965L7.16759 11.3492L6.39262 15.866L10.3263 13.7982"
      stroke="currentColor"
      strokeWidth={1.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M16.0236 14.0102L14.8802 13.629L14.499 12.4855C14.375 12.1161 13.7639 12.1161 13.6399 12.4855L13.2587 13.629L12.1153 14.0102C11.9306 14.0717 11.8057 14.2447 11.8057 14.4393C11.8057 14.634 11.9306 14.8069 12.1153 14.8684L13.2587 15.2496L13.6399 16.3931C13.7014 16.5778 13.8753 16.7027 14.0699 16.7027C14.2646 16.7027 14.4375 16.5778 14.4999 16.3931L14.8811 15.2496L16.0245 14.8684C16.2092 14.8069 16.3342 14.634 16.3342 14.4393C16.3342 14.2447 16.2092 14.0717 16.0245 14.0102H16.0236Z"
      fill="currentColor"
    />
    <path
      d="M15.2024 5.41835C15.5774 5.41835 15.8814 5.11434 15.8814 4.73932C15.8814 4.36431 15.5774 4.0603 15.2024 4.0603C14.8274 4.0603 14.5234 4.36431 14.5234 4.73932C14.5234 5.11434 14.8274 5.41835 15.2024 5.41835Z"
      fill="currentColor"
    />
  </svg>
)
const ForwardRef = forwardRef(StarSparkleSvg)
export default ForwardRef
